<div class="deliverable-card">
    <div class="deliverable-head">
        <span class="deliverable-icon">
            <i class="ph-bold {{ iconFor(primaryFile?.format || '') }} icon-primary icon-24" aria-hidden="true"></i>
        </span>
        <div class="deliverable-meta">
            <div class="deliverable-title">{{ title }}</div>
            <div class="deliverable-sub" *ngIf="primaryFile">
                {{ primaryFile.fileName }} · {{ primaryFile.sizeLabel }}
            </div>
        </div>
    </div>

    <div class="deliverable-actions">
        <ng-container *ngIf="files.length > 1; else singleDownload">
            <button mat-flat-button
                    color="primary"
                    type="button"
                    [disableRipple]="true"
                    [matMenuTriggerFor]="downloadMenu">
                <i class="ph-bold ph-download-simple icon-16" aria-hidden="true"></i>
                Download
                <i class="ph-bold ph-caret-down icon-16" aria-hidden="true"></i>
            </button>
            <mat-menu #downloadMenu="matMenu" class="v2-panel">
                <a *ngFor="let f of files; trackBy: trackByFormat"
                   mat-menu-item
                   [href]="f.downloadUrl"
                   target="_blank" rel="noopener noreferrer">
                    {{ formatLabel(f.format) }}
                </a>
            </mat-menu>
        </ng-container>

        <ng-template #singleDownload>
            <a *ngIf="primaryFile"
               mat-flat-button
               color="primary"
               [disableRipple]="true"
               [href]="primaryFile.downloadUrl"
               target="_blank" rel="noopener noreferrer">
                <i class="ph-bold ph-download-simple icon-16" aria-hidden="true"></i>
                Download {{ formatLabel(primaryFile.format) }}
            </a>
        </ng-template>
    </div>
</div>
